import React from 'react';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CustomTooltip } from 'app/components/Common/Tooltips/CustomTooltip';
import { useTranslation } from 'react-i18next';
interface NavigationStatusIconPropTypes {
  isNotComplete?: boolean;
  isComplete?: boolean;
  isNotRequired?: boolean;
  tooltipMessage?: string;
}
export const NavigationStatusIcon = ({
  isNotComplete,
  isComplete,
  isNotRequired,
  tooltipMessage,
}: NavigationStatusIconPropTypes) => {
  const { t } = useTranslation();

  //default tooltip message
  const toolTipContent = (notCompleted, completed, notRequired) => {
    if (notRequired) {
      return t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.navigationStatus.notRequired');
    } else if (completed) {
      return t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.navigationStatus.completed');
    }
    return t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.navigationStatus.notCompleted');
  };

  //rendering icons based on props-default rendering Unchecked Icon
  const renderIcons = (isNotComplete, isComplete, isNotRequired) => {
    if (isNotRequired) {
      return <CheckCircleIcon style={{ color: '#797979' }} />;
    } else if (isComplete) {
      return <CheckCircleIcon style={{ color: '#1898D7' }} />;
    }
    return <RadioButtonUncheckedIcon style={{ color: '#797979' }} />;
  };
  // based on props following component is rendred
  return (
    <CustomTooltip
      placement={'bottom'}
      tooltipContent={tooltipMessage ? tooltipMessage : toolTipContent(isNotComplete, isComplete, isNotRequired)}
    >
      {renderIcons(isNotComplete, isComplete, isNotRequired)}
    </CustomTooltip>
  );
};
